module.exports = __webpack_public_path__ + "logo.png?e48d4feffc6f26089e1ac11fdfee6f6b";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 51
// module chunks = 0